<div class="fc-dialog-header">
  <div class="fc-dialog-title">
    <span class="material-icons fc-dialog-title-icon">error_outline</span>
    <h2 mat-dialog-title>Error list — {{ machineName }}</h2>
  </div>
  <button mat-icon-button class="fc-dialog-close" aria-label="Close" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="fc-dialog-meta">
  <span class="fc-meta-item">
    <span class="fc-meta-label">Period</span>
    <span class="fc-meta-value">{{ fromFormatted }} – {{ toFormatted }}</span>
  </span>
  <span class="fc-meta-sep"></span>
  <span class="fc-meta-item">
    <span class="fc-meta-label">Errors</span>
    <span class="fc-meta-value" [class.fc-meta-value--danger]="errorList.length > 0">{{ errorList.length }}</span>
  </span>
</div>

<mat-dialog-content class="fc-dialog-body">
  <table class="fc-err-table">
    <thead>
      <tr>
        <th class="fc-err-th">Timestamp</th>
        <th class="fc-err-th">Description</th>
      </tr>
    </thead>
    <tbody *ngIf="errorList.length === 0">
      <tr>
        <td class="fc-err-td fc-err-empty" colspan="2">No errors in the selected period.</td>
      </tr>
    </tbody>
    <tbody *ngIf="errorList.length > 0">
      <tr class="fc-err-row" *ngFor="let error of errorList">
        <td class="fc-err-td fc-err-td--ts">{{ error.dateTimeState }}</td>
        <td class="fc-err-td">{{ error.description }}</td>
      </tr>
    </tbody>
  </table>
</mat-dialog-content>
